import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=08b94c25"
import script from "./Activities.vue?vue&type=script&lang=ts"
export * from "./Activities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports